import getValue from "../get-value/boolean";
import { isNil, get } from "lodash";

export default function(value) {
  return isNil(get(value, "value"));
}
